import { render, staticRenderFns } from "./BtnInputFile.vue?vue&type=template&id=b482c100&scoped=true"
import script from "./BtnInputFile.vue?vue&type=script&lang=js"
export * from "./BtnInputFile.vue?vue&type=script&lang=js"
import style0 from "./BtnInputFile.vue?vue&type=style&index=0&id=b482c100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b482c100",
  null
  
)

export default component.exports